import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentService } from '../services/payment.service';
import { LoaderService } from '../services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from '../services/log.service';

// interface dialogData{
//   warning: boolean,
//   paying: boolean,
//   payment: any,
//   for: string,
//   pay: any
// }

@Component({
  selector: 'app-payperbyte-warn-dialog',
  templateUrl: './payperbyte-warn-dialog.component.html',
  styleUrls: ['./payperbyte-warn-dialog.component.css']
})

export class PayperbyteWarnDialogComponent implements OnInit {

  public doc;
  constructor(
    public _payment: PaymentService,
    public _load: LoaderService,
    public snackbar: MatSnackBar,
    public dialog: MatDialog,
     private dialogRef: MatDialogRef<PayperbyteWarnDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any, public log: LogService
    
    ) { }
  
  // public {warning, paying} = this.data;

  public warning = this.data.warning;
  public paying = this.data.paying;
  public payment = this.data.payment;

  public foundPaymentUpload;
  public slipAmount = 0;

  public d = new Date();
  public slipDate = this.formatDate(this.d);

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  public showUploaded = false;
  selectedFile : any = null;
  public loading = false;

  selectedHostel: any;
  public hostelArr = [];

  public reference = "";
  public display = 0;
  public payData;
  public sufficient = false; //if transfer is sufficient to satisfy current payment
  public message = "";
  closer():void{
    this.dialogRef.close();
  }
  ngOnInit() {
    if(this.data.for == 'pay_upload'){
      this.getUploadedPayments()
    }

    if(this.data.for == 'hostel'){
      this.hostelArr = this.data.hostels;
    }
  }

  verifyPayment(){
    this._load.emitChange(true)
    this._payment.verifyPayment({reference: this.reference}).subscribe(data => {
      this._load.emitChange(false)
      if(data.success){
        this.payData = data;
        this.display = 1;
        if(data.amount >= this.data.pay.amount){
          this.sufficient = true;
        }else{
          this.sufficient = false;
        }
      }else{
        // console.log("reaching here!", data.message)
        this.message = data.message;
      }
    })
  }

  makePayment(){
    this.dialogRef.close(this.reference)
  }

  getUploadedPayments(){
    this._payment.getUploadedPayments({termd_id: this.data.pay.termd_id}).subscribe(data => {
      if(data.length > 0){
        this.foundPaymentUpload = data;
      }
    })
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }

  uploadSlip(){
    if(this.selectedFile){
      if(!this.slipAmount){
        this.snackbar.open("Amount field is required for payment slip upload")
        return;
      }
      this.loading = true;
      let form  = new FormData();
      form.append('slip', this.selectedFile, this.selectedFile.name);
      form.append('termd_id', this.data.pay.termd_id);

      // *100 because payments in online_payment are in kobo
      form.append('amount', (this.slipAmount*100).toString());
      form.append('payment_date', (this.slipDate));
      this._payment.uploadPayslip(form).subscribe(data => {
        this.loading = false;
        if(data.success){
          this.selectedFile = "";
          this.slipAmount = 0;
          this.getUploadedPayments();
          this.showUploaded = true;

          this.snackbar.open("Slip uploaded succefully, awaiting approval", "Dismiss",{
            duration: 5000
          })
          this.log
            .addLog({
            action: "Upload",
            component: "Payperbyte Warn Dialog",
            details: `Uploaded Payment Slip`
          }).subscribe(data)
        }else{
          this.snackbar.open(data.message, "Dismiss");
        }
      })
    }
  }

  viewImage(slip){
    this.dialog.open(PayperbyteWarnDialogComponent,{
      data: {for: 'view_image', image: slip}
    })
  }

  submitHostel(){
    this.dialogRef.close(this.selectedHostel)
  }
}
